import { cloneDeep } from "lodash";
import {
  RECEIVE_VIDEO_NOTES,
  RECEIVE_VIDEO_NOTE,
  RECEIVE_PRODUCT_NOTES,
  RECEIVE_PRODUCT_NOTE,
  RECEIVE_INFLUENCER_NOTES,
  RECEIVE_INFLUENCER_NOTE,
} from "./NoteActions";

export const videoNotes = (state = [], payload = {}) => {
  const { type, notes, note } = payload;
  const newState = cloneDeep(state);
  switch (type) {
    case RECEIVE_VIDEO_NOTES:
      return notes;
    case RECEIVE_VIDEO_NOTE:
      const i = state.findIndex((n) => n.video_id === note.video_id);
      if (i === -1) {
        newState.push(note);
      } else {
        newState[i] = note;
      }
      return newState;
    default:
      return state;
  }
};

export const productNotes = (state = [], payload = {}) => {
  const { type, notes, note } = payload;
  const newState = cloneDeep(state);
  switch (type) {
    case RECEIVE_PRODUCT_NOTES:
      return notes;
    case RECEIVE_PRODUCT_NOTE:
      const i = state.findIndex((n) => n.product_id === note.product_id);
      if (i === -1) {
        newState.push(note);
      } else {
        newState[i] = note;
      }
      return newState;
    default:
      return state;
  }
};

export const influencerNotes = (state = [], payload = {}) => {
  const { type, notes, note } = payload;
  const newState = cloneDeep(state);
  switch (type) {
    case RECEIVE_INFLUENCER_NOTES:
      return notes;
    case RECEIVE_INFLUENCER_NOTE:
      const i = state.findIndex(
        (n) => n.video_author_id === note.video_author_id
      );
      if (i === -1) {
        newState.push(note);
      } else {
        newState[i] = note;
      }
      return newState;
    default:
      return state;
  }
};
